/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React,{useState,useContext} from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";
import { validateEmail } from "../../../CommonMethods/EmailValidator";
import Toast from "../../../components/Toast";
import GlobalContext from "../../../components/Context/GlobalContext";
import { userService } from "../../../services/user.services";
import Header from "./Header";

export default function forgotPaasword() {
    const navigateLogin = useNavigate();
    const resetPassword = useNavigate();
    const [loading, setloading] = useState(false)
    const [email, setemail] = useState('');
    const [errormessage, seterrormessage] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false)
    const {setToastmessage, setToastErrorMessage,Toastmessage} = useContext(GlobalContext)

    const isError=(key)=> submitSelected &&!loading &&(key===''||errormessage!=='');
    const handleSubmit =async(e)=>{
        e.preventDefault()
        seterrormessage('')
        setsubmitSelected(true);
        setloading(true)
        if(email===''){
            seterrormessage("This field is mandatory");
            setloading(false)

            return;

        }
        if(validateEmail(email.trim())){
            seterrormessage("Invalid email address");
            setloading(false)   
            return

        }
        try {
            const response = await userService.forgotPassword(`admin-users/forgot-password`, {email:email});   
            if(!response.error){
                setToastmessage(response.data.message)
                setloading(false);
                navigateLogin("/")
            }else{
                seterrormessage(response.message.response.data.message);
                setloading(false);
                return
            }
        } catch (error) {
            seterrormessage("Please enter valid details")
            setloading(false)
        }
    }
    const handleClick=()=>{
        resetPassword("/set-new-password")
    }
    return (
        <div className="">
            <div className="w-[100vw] h-[100vh] bg-[#F5F5F5] flex flex-col">
                {/* <header className="pt-[23px] pb-[24px] px-[24px] bg-primary flex space-x-[9px] items-center">
                    <h1 className="text-white font-minionpro text-xl font font-medium">
                        Maison QR
                    </h1>
                    <img src="../../assets/images/vertical.svg" alt="" />
                    <span className="font-minionpro text-base font-medium text-white">
                        Admin
                    </span>
                </header> */}
                <Header />

                <div className=" w-[100wh] h-[100vh] flex justify-center items-center relative ">
                    <div className="w-fit px-[16px] md:px-[52px] text-center bg-white m-4 rounded-[8px]">
                        <h1 className="pt-[38px] text-[#666] font-minionpro text-2xl font-normal">
                            Forgot Password
                        </h1>
                        <p className="font-minionpro text-[#666] text-base font-normal pt-[16px]">
                            Please enter your registered email address to initiate the
                            password reset.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className=" pt-[36px]"><div className="flex justify-center">
                                <div className="  w-full flex justify-center flex-col items-center">
                                    <div className='relative w-[65%] md:w-[65%]'>
                                        <input 
                                            id="email" 
                                            data-testid="email"
                                            value={email} 
                                            onFocus={()=>setsubmitSelected(false)}
                                            placeholder='' 
                                            onChange={(e)=>setemail(e.target.value)}
                                            // className={`w-full ${isError(email) ? 'input-error' : 'input-border'}  pl-4 pr-[46px] rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`}
                                            className ={`w-full ${isError(email) ? 'input-error text-[#FC4523]' : 'input-border'} font-semibold  pl-3 pr-[52px]  pt-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer `}
                                        />
                                        {/* <label for="email" class={`px-4 absolute text-[#1F1F1F] block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-1 peer-focus:text-[#1F1F1F]  peer-focus:dark: ${isError(email) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}>Email address</label> */}
                                        <label for="email" class={`peer-focus:dark: ${isError(email) ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} px-3 left-1  absolute text-[#1F1F1F] block  peer-focus:font-normal ${email?.length > 0 ? 'font-normal' : 'font-semibold'}  leading-tight text-base duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] peer-focus:text-[#1F1F1F]  peer-focus:dark: peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3`}>Email address</label>

                                        <button type="button" className="cursor-pointer outline-none absolute top-[50%] -translate-y-[50%] right-3.5">
                                            <img loading="lazy" src={`/assets/images/${isError(email)?'email-error.svg':'email.svg'}`} alt="password-show" className="password-show" />

                                        </button>

                                    </div>
                                    {submitSelected&&errormessage!==''&&!loading &&<ErrorMessage message={errormessage} error classKey={'w-[65%] mt-[8px] font-minionpro font-normal text-[14px] text-[#FC4523] text-start '} />}

                                        
                                </div>

                            </div>

                                
                            </div>

                        </form>
                        
                        <Button
                            text="Reset Password"
                            type="submit"
                            testId="login-btn"
                            disabled={loading ||submitSelected}
                            handleClick={handleSubmit}
                            loading={loading}
                            classKey={`w-[65%]  px-4 py-[16px] mt-4 text-white rounded-[0.75rem] font-minionpro font-bold text-lg" ${isError(email) ? 'bg-[#9E2064] opacity-[0.3]' : 'bg-[#9E2064]'}`} />
                        {/* <button
                            className="w-[65%] bg-primary px-4 py-[16px] mt-4 text-white rounded-[0.75rem] font-minionpro font-bold text-lg"
                            type="submit"
                            onClick={() => resetPassword("/setnewpassword")}
                        >
                            Reset Password
                        </button> */}
                        <div
                            className="flex space-x-[4px] justify-center items-center mt-[21px] mb-[18px] cursor-pointer"
                            onClick={() => navigateLogin("/login")}
                        >
                            <img
                                src="../../assets/images/arrow-left.png"
                                alt="left-arrow"
                            />
                            <p className="font-minionpro font-semibold text-xs">
                                Return to Sign in
                            </p>
                        </div>
                    </div>

                    {/* success modal */}
                    
                </div>
            </div>
        </div>
    );
}
